import { type ReactNode } from 'react';
import { TiptapEditor } from './tiptap-editor';
import { ComposerEmbedAdder } from './composer-embed-adder';
import { ComposerMediaUpload } from './composer-media-upload';
import type { ComposerData } from '../types-comunicados';

type Props = {
  data: ComposerData;
  onUpdate: <K extends keyof ComposerData>(
    key: K,
    value: ComposerData[K]
  ) => void;
  comunicadoId: string | undefined;
  mediaFiles: string[];
  onMediaChanged: () => void;
};

const TITLE_INPUT =
  'w-full rounded-lg border border-white/[0.06] bg-surface px-md py-sm text-[20px] font-semibold text-text-primary placeholder:text-text-tertiary focus:border-brand-red/40 focus:outline-none';

function TitleInput({
  value,
  onChange,
}: {
  value: string;
  onChange: (v: string) => void;
}): ReactNode {
  return (
    <input
      type="text"
      placeholder="Título (opcional)"
      maxLength={120}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={TITLE_INPUT}
    />
  );
}

function EditorBlock(p: Props): ReactNode {
  const onBodyChange = (html: string, json: unknown): void => {
    p.onUpdate('body_html', html);
    p.onUpdate('body_json', json);
  };
  return (
    <TiptapEditor
      initialHtml={p.data.body_html}
      initialJson={p.data.body_json}
      onChange={onBodyChange}
    />
  );
}

export function ComposerEditorSide(p: Props): ReactNode {
  return (
    <div className="space-y-md">
      <TitleInput
        value={p.data.title}
        onChange={(v) => p.onUpdate('title', v)}
      />
      <EditorBlock {...p} />
      <ComposerEmbedAdder
        urls={p.data.embed_urls}
        onChange={(urls) => p.onUpdate('embed_urls', urls)}
      />
      <ComposerMediaUpload
        comunicadoId={p.comunicadoId}
        files={p.mediaFiles}
        onChanged={p.onMediaChanged}
      />
    </div>
  );
}
